export type ReducedAnimationParameter =
  | 'always'
  | 'never'
  | 'mobile'
  | 'desktop';

export type AnimationState = {
  mobile?: boolean;
  desktop?: boolean;
};

export const defaultAnimationState: AnimationState = {
  mobile: true,
  desktop: true,
};

export function reducedAnimationResponseToAnimationParam(
  param?: ReducedAnimationParameter
): AnimationState {
  if (param === 'always') return { mobile: false, desktop: false };
  if (param === 'never') return { mobile: true, desktop: true };
  if (param === 'mobile') return { mobile: false, desktop: true };
  if (param === 'desktop') return { mobile: true, desktop: false };

  return defaultAnimationState;
}
